import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard } from '@next/core-lib/authorization';

import { ProductionPurposeCategoryComponent } from './production-purpose-category.component';

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forChild([
      {
        path: 'production-purpose-category',
        component: ProductionPurposeCategoryComponent,
        canActivate: [AuthGuard],
      },
    ]),
  ],
})
export class ProductionPurposeCategoryRoutingModule {}
